import { useParams } from 'react-router-dom';

import SessionBreadcrumbs from '../session-breadcrumbs/session-breadcrumbs';

const SessionHeaderRow = () => {
  const params = useParams();
  const sessionUuid = params?.sessionUuid;

  if (!sessionUuid) return null;
  return (
    <div data-component="SessionHeaderRow" className="flex fd-row jc-space-between ai-center">
      <div className="flex-row flex-1">
        <SessionBreadcrumbs sessionUuid={sessionUuid} />
      </div>
    </div>
  );
};

export default SessionHeaderRow;
